'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    $('[data-buy-voucher]', this).click(function () {
        var _this = this;

        if (!_abp2.default.session) {
            (0, _ajax2.default)({
                url: '/Account/AuthenticateAnonymous',
                method: 'post',
                contentType: 'application/json',
                dataType: 'json'
            }).done(function (res) {
                $('input[name="__RequestVerificationToken"]').val(_cookie2.default.getCookie('XSRF-TOKEN'));
                window.location.href = (0, _urls2.default)('buyVoucher', { id: $(_this).attr("data-buy-voucher") });
            }).fail(function (err) {});
        } else {
            window.location.href = (0, _urls2.default)('buyVoucher', { id: $(this).attr("data-buy-voucher") });
        }
    });
};

var _urls = require('../urls');

var _urls2 = _interopRequireDefault(_urls);

var _abp = require('abp');

var _abp2 = _interopRequireDefault(_abp);

var _ajax = require('linksoft/utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _cookie = require('linksoft/utils/cookie');

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = require("jquery");

;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/buyVoucher.js
// module id = 1166
// module chunks = 0